import React from "react";

import Tabela from "../comum/Tabela";
import { num, pct, reais } from "../comum/formato";

// O que a Brendi não mostra: quais produtos o anúncio vendeu, com custo e lucro.
export default function ProdutosDaCampanha({ produtos }) {
  const colunas = [
    { id: "nome", rotulo: "Produto", valor: (p) => p.nome, render: (p) => <b>{p.nome}</b> },
    { id: "quantidade", rotulo: "Qtd", alinhar: "direita", valor: (p) => p.quantidade, render: (p) => num(p.quantidade) },
    { id: "pedidos", rotulo: "Pedidos", alinhar: "direita", valor: (p) => p.pedidos, render: (p) => p.pedidos },
    { id: "faturado", rotulo: "Faturado", alinhar: "direita", valor: (p) => p.faturado, render: (p) => reais(p.faturado) },
    { id: "custo", rotulo: "Custo", alinhar: "direita", valor: (p) => p.custo, render: (p) => (p.custo == null ? <span className="text-muted-foreground" title="Produto sem custo cadastrado">—</span> : reais(p.custo)) },
    { id: "lucro", rotulo: "Lucro", alinhar: "direita", valor: (p) => p.lucro, render: (p) => (p.lucro == null ? <span className="text-muted-foreground">—</span>
      : <span className={p.lucro < 0 ? "text-red-500" : "text-emerald-600 dark:text-emerald-400"}>{reais(p.lucro)} <span className="text-[11px] text-muted-foreground">({pct(p.margem_pct)})</span></span>) },
  ];
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5">
      <h3 className="font-semibold mb-2">Produtos vendidos pelo anúncio</h3>
      <Tabela colunas={colunas} linhas={produtos || []} ordemInicial={{ id: "faturado", desc: true }} vazio="Nenhum produto vendido no período." e2e="tabela-produtos-meta" chave={(p, i) => p.produto_id || i} />
    </section>
  );
}
